const configTable = [
    {
        prop: "equityLevel",
        label: "权益名称",
    },
    {
        prop: "equityItem",
        label: "权益描述",
    },
    {
        prop: "levelName",
        label: "会员消费等级",
    },
    {
        prop: "sortIndex",
        label: "排序",
    },
    {
        prop: "state",
        label: "是否启用",
    },
    {
        prop: "createUserName",
        label: "创建人",
    },
    {
        prop: "createTime",
        label: "创建时间",
    },
    {
        prop: "updateUserName",
        label: "最后修改人",
    },
    {
        prop: "updateTime",
        label: "最后修改时间",
        cinfigWidth:"120px"
    }
]
export default configTable